<aims-common-table 
    id="eeoType-table" 
    [dataSource]="eeoType | async" 
    [header]="eeoTypeHeader" 
    [pageSize]="10"
    [permissions]="tablePermissions" 
    [addRowInitialObject]="initialTableElement" 
    (rowUpdated)="handleRowUpdate($event)"
    (rowAdded)="handleRowAdd($event)">
</aims-common-table>